// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select--3j69r","Space":"Space--2RAy-","Icon":"Icon--287WJ"};